import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import Button from '~components/Button';
import ArrowLine from '~components/Icon/ArrowLine';
import useGetCompanyStates from '~hooks/query/company/useCompanyStates';
import { useRouterQuery } from '~hooks/useRouterQuery';

import ShutdownModal from './Modal';
import * as S from './style';

export default function ManageCompanyInfo() {
  const router = useRouter();
  const companyId = useRouterQuery('companyId');
  const { data: companyStates, status: statusCompanyStates } = useGetCompanyStates(companyId);
  const [isBlockedComapny, setIsBlockedComapny] = useState<boolean>();
  // const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    const url = `/block/${companyId}${isBlockedComapny ? '?type=unblock' : ''}`;
    router.push(url);
  };

  useEffect(() => {
    setIsBlockedComapny(
      !companyStates?.salary || !companyStates?.employee || !companyStates?.sales,
    );
  }, [companyStates]);

  if (statusCompanyStates !== 'success' || companyStates?.deleted) {
    return null;
  }

  return (
    <S.Wrapper>
      <S.Heading>이 기업의 관리자이신가요?</S.Heading>
      <Button
        onClick={handleClick}
        variant='light'
        data-attribute-id='company__request__click'
        trailing={
          <S.ArrowIconWrapper>
            <ArrowLine />
          </S.ArrowIconWrapper>
        }>
        {isBlockedComapny ? '블록해제 및 기업정보 수정 요청하기' : '블록 및 기업정보 수정 요청하기'}
      </Button>
      {/* {isOpen && <ShutdownModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />} */}
    </S.Wrapper>
  );
}
